import { render, staticRenderFns } from "./VMenu.vue?vue&type=template&id=01a944fd&scoped=true&"
import script from "./VMenu.vue?vue&type=script&lang=js&"
export * from "./VMenu.vue?vue&type=script&lang=js&"
import style0 from "./VMenu.vue?vue&type=style&index=0&id=01a944fd&lang=scss&scoped=true&"
import style1 from "./VMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a944fd",
  null
  
)

export default component.exports